import { motion } from 'framer-motion';
import { Card } from '@/components/ui/Card';

const stats = [
  {
    metric: '82%',
    label: "Don't get credit",
    source: 'Gallup Research',
  },
  {
    metric: '74%',
    label: 'Feel left behind by AI',
    source: 'Gartner Study',
  },
  {
    metric: '69%',
    label: 'Struggle to speak up',
    source: 'Harvard Business Review',
  },
  {
    metric: '75%',
    label: 'Feel stuck, no path',
    source: 'Oracle Study',
  },
];

export const ProofSection = () => {
  return (
    <section className="relative py-24 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-primary/[0.03] to-transparent dark:via-primary/[0.06]" />
      <div className="container relative mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 tracking-tight">
            <span className="text-foreground">Hard Work </span>
            <span className="bg-gradient-to-r from-primary via-violet-500 to-fuchsia-500 bg-clip-text text-transparent">
              Isn't Enough
            </span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Research reveals the gap between effort and recognition
          </p>
        </motion.div>

        <div className="grid md:grid-cols-4 gap-8 max-w-6xl mx-auto">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.08 }}
            >
              <Card className="p-6 sm:p-8 text-center border-2 rounded-2xl bg-gradient-to-br from-primary/5 to-violet-500/5 hover:border-primary/40 transition-all duration-300 shadow-sm">
                <div className="text-5xl md:text-6xl font-bold text-primary mb-4">
                  {stat.metric}
                </div>
                <div className="text-lg font-medium text-foreground mb-2">
                  {stat.label}
                </div>
                <div className="text-sm text-muted-foreground">
                  {stat.source}
                </div>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

